import { render, staticRenderFns } from "./IconTextButton.vue?vue&type=template&id=f7d5dca6&scoped=true"
import script from "./IconTextButton.vue?vue&type=script&lang=ts"
export * from "./IconTextButton.vue?vue&type=script&lang=ts"
import style0 from "./IconTextButton.vue?vue&type=style&index=0&id=f7d5dca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d5dca6",
  null
  
)

export default component.exports